import axios from "axios";
import { API_URL } from "./constants";

const api = axios.create({
    baseURL: API_URL,
});

const deviceId = localStorage.getItem('deviceId');

api.interceptors.response.use(
    response => response,
    async (error) => {
        const status = error.response?.status;

        // faqat 401 bo'lsa va 423 emas bo'lsa refresh qilamiz
        if (status === 401 && !error.config._retry) {
            error.config._retry = true;

            try {
                const refreshResponse = await axios.post(`${API_URL}/auth/token/reffresh`, {}, {
                    headers: {
                        "Content-Type": "application/json",
                        "device-id": deviceId,
                        Authorization: `Bearer ${localStorage.getItem("refresh_token")}`
                    }
                });

                const newToken = refreshResponse.data.access_token;
                const newRefreshToken = refreshResponse.data.refresh_token;

                localStorage.setItem("token", newToken);
                localStorage.setItem("refresh_token", newRefreshToken);
                window.location.reload()

                console.log("token yangilandi", refreshResponse?.data);

                if (!error.config.headers) {
                    error.config.headers = {};
                }
                error.config.headers["Authorization"] = `Bearer ${newToken}`;
                error.config.withCredentials = true;

                return axios(error.config);
            } catch (refreshError) {
                console.log("Refresh token ishlamadi:", refreshError);
                localStorage.removeItem("token");
                localStorage.removeItem("refresh_token");
                window.location.href = "/login";
                return Promise.reject(refreshError);
            }
        }

        // Agar 423 qaytsa refresh qilmaymiz
        if (status === 423) {
            console.warn("423 status: Locked - refresh qilinmadi");
            localStorage.removeItem("access_token");
            localStorage.removeItem("refresh_token");
            window.location.href = "/";
        }

        return Promise.reject(error);
    }
);

export default api;
